
import { formatDistance, format } from "date-fns";
import { ptBR } from "date-fns/locale";

export const formatRelativeDate = (dateString: string): string => {
  if (!dateString) return "Unknown date";
  
  try {
    const date = new Date(dateString);
    return formatDistance(date, new Date(), { addSuffix: true, locale: ptBR });
  } catch (error) {
    console.error("Error formatting date:", error);
    return "Invalid date";
  }
};

/**
 * Formats a date string to a simple readable format
 */
export const formatDate = (dateString: string): string => {
  if (!dateString) return "N/A";
  
  try {
    const date = new Date(dateString);
    return format(date, "dd/MM/yyyy HH:mm", { locale: ptBR });
  } catch (error) {
    console.error("Error formatting date:", error);
    return "N/A";
  }
};

/**
 * Formats a URL for display by removing protocol and trailing slashes
 */
export const formatSocialMediaUrl = (url: string): string => {
  if (!url) return "";
  
  try {
    // Remove protocol (http://, https://)
    let formatted = url.replace(/^https?:\/\//, '');
    
    // Remove trailing slash if present
    formatted = formatted.replace(/\/$/, '');
    
    // Remove www. if present
    formatted = formatted.replace(/^www\./, '');
    
    // Truncate if too long
    if (formatted.length > 25) {
      formatted = formatted.substring(0, 22) + '...';
    }
    
    return formatted;
  } catch (error) {
    return url;
  }
};

